import { get, put, post } from '../request'

export const me = (params) => get('api/users/me', params)
export const getUsers = (params) => get('api/users', params)
export const fetchUser = (id) => get('api/users', { filters: { id } })
export const updateUser = (id, params) => put(`api/users/${id}`, params)
export const createUser = (data) => post(`api/users`, { data })
